export default {"src":"/_next/static/media/datasheets-icon.3919c8b0.svg","height":35,"width":30,"blurWidth":0,"blurHeight":0};